import styled from 'styled-components';

export const ProfileContainer = styled.div`
    padding: 1rem 2.5rem;
`;

export const ProfileSectionContainer = styled.div`
    margin-top: 3rem;
    padding: 0 4.75rem;
`;
